/*
 * @Date: 2020-03-16 15:38:52
 * @LastEditors: OBKoro1
 * @LastEditTime: 2020-11-06 13:17:05
 */
// 获取url 传递的参数
export function getUrlKey(name) {
  return (
    decodeURIComponent(
      (new RegExp("[?|&]" + name + "=" + "([^&;]+?)(&|#|;|$)").exec(
        location.href
      ) || [, ""])[1].replace(/\+/g, "%20")
    ) || null
  )
}

export function GetUrlRelativePath(){
  var url = document.location.toString();
  var arrUrl = url.split("//");
  var start = arrUrl[1].indexOf("/");
    var relUrl = arrUrl[1].substring(start);//stop省略，截取从start开始到结尾的所有字符

  if(relUrl.indexOf("?") != -1){
      relUrl = relUrl.split("?")[0];
  }
  relUrl = window.location.protocol + '//' + window.location.host +  relUrl
  return relUrl;
}



// WEBPACK FOOTER //
// ./src/utils/index.js